export default __webpack_public_path__ + "static/media/19.94d36298.jpg";